import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { editContent } from '../../modules/editor';
import { RGBToHex } from '../../util/color';


import ColorPickerPanel from './ColorPickerPanel';

type ColorPickerProps = {
	target: string;
	value: string;
	children?: React.ReactNode;
	position?: 'left' | 'right';
	showLabel?: boolean;
	showValueText?: boolean;
	showChip?: boolean;
	showChildren?: boolean;
	labelText?: string;
	isShow?: boolean;
	showResetValue?: boolean;
};

const MAX_PALLETTE_COUNT = 10;
function ColorPicker({ target, value, children, position, showLabel, showValueText, showChip, showChildren, labelText, isShow, showResetValue }: ColorPickerProps) {
	const dispatch = useDispatch();
	const [show, setShow] = useState(isShow);
	
	const toggleShow = () => {
		setShow(!show);
	}

	const close = () => {
		setShow(false);
	}

	const onChangeValue = (value:string) => {		
		dispatch(editContent({ target: target, data: value }));		
	}

	const onResetValue = () => {
		dispatch(editContent({ target: target, data: '' }));		
	}

	return (
		<div className={position ? `color-picker ${position}` : 'color-picker'}>
			{
				showLabel && (
					<span className="label">{labelText}</span>
				)
			}
			<button
				className="color-picker-btn"
				onClick={toggleShow} 				
			>	
				{
					showChip && (
						<span 
							style={{ background: value }} 
							className={value?.length === 0 ? 'color-picker-chip empty' : 'color-picker-chip'}
						></span>
					)
				}
				{
					showValueText && (
						<span className="color-picker-value">
							{
								value ? RGBToHex(value) : '없음'
							}
						</span>
					)					
				}
				{
					showChildren && (
						children
					)
				}
			</button>
			{
				show && (
					<ColorPickerPanel 
						value={value}
						position={position}
						onChangeValue={onChangeValue}
						onResetValue={onResetValue}
						showResetValue={showResetValue}
						onClose={close}
					/>
				)
			}
		</div>
	);
}

ColorPicker.defaultProps = {
	showValueText: false,
	showChip: true,
	showLabel: false,
	showChildren: false,
	isShow: false,
	showResetValue: true,
};

export default ColorPicker;